import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { NgChartsModule } from 'ng2-charts';
import { MsalRedirectComponent } from '@azure/msal-angular';

import { CoreModule } from './core/core.module';
import { MatDialogRef } from '@angular/material/dialog';
import { MsalService,MsalModule } from '@azure/msal-angular';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { HeaderModule, AppEnvironmentState, ActionRequiredState, UserState, LIBRARY_CONFIG, SidebarV2Module, PageLayoutModule, PermissionsState, FeatureFlagConfigurationState, GeaMissingTranslationHandler, GeaTranslateHttpLoader, HeaderConfig } from '@gea/digital-ui-lib';
import { TableV2Module } from '@gea/digital-ui-lib';

import { DigitalComponent } from './smartfiltration/components/graph/digital/digital.component';
import { TableComponent } from './smartfiltration/components/graph/table/table.component';
import { TrendV2Component } from './smartfiltration/components/graph/trend-v2/trend-v2.component';
import { OverviewComponent } from './smartfiltration/containers/overview/overview.component';
import { ProcessComponent } from './smartfiltration/containers/process/process.component';
import { VerticalBarComponent } from './smartfiltration/components/graph/vertical-bar/vertical-bar.component';
import { PieComponent } from './smartfiltration/components/graph/pie/pie.component';
import { CipComponent } from './smartfiltration/containers/cip/cip.component';
import { DatepickerComponent } from './smartfiltration/components/others/datepicker/datepicker.component';
import { CardLastChangeComponent } from './smartfiltration/components/others/card-last-change/card-last-change.component';
import { CardNextAuditComponent } from './smartfiltration/components/others/card-next-audit/card-next-audit.component';
import { ListOfCipComponent } from './smartfiltration/containers/list-of-cip/list-of-cip.component';
import { ListOfProductionComponent } from './smartfiltration/containers/list-of-production/list-of-production.component';
import { StatusTableComponent } from './smartfiltration/components/others/status-table/status-table.component';
import { GanttComponent } from './smartfiltration/components/graph/gantt/gantt.component';
import { ConsumptionComponent } from './smartfiltration/containers/consumption/consumption.component';
import { FluxTestComponent } from './smartfiltration/containers/flux-test/flux-test.component';
import { ChemicalComponent } from './smartfiltration/containers/chemical/chemical.component';
import { ServiceComponent } from './smartfiltration/containers/service/service.component';
import { TrendPopupComponent } from './smartfiltration/components/others/trend-popup/trend-popup.component';
import { TreeViewComponent } from './smartfiltration/containers/tree-view/tree-view.component';
import { ShowTimePopupComponent } from './smartfiltration/components/others/show-time-popup/show-time-popup.component';
import { HeaderComponent } from './smartfiltration/components/others/header/header.component';

import { NgxsModule } from '@ngxs/store';

import { MachineTypeDirective } from './smartfiltration/directives/machine-type.directive';
import { DigitalConsumComponent } from './smartfiltration/components/graph/digital-consum/digital-consum.component';
import { DigitalConsumV2Component } from './smartfiltration/components/graph/digital-consum-v2/digital-consum-v2.component';
import { DigitalConsumV3Component } from './smartfiltration/components/graph/digital-consum-v3/digital-consum-v3.component';
import { CommonModule } from '@angular/common';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from 'src/environments/models/environment.model';

export const HEADER_CONFIG = new InjectionToken<HeaderConfig>('HeaderConfig');

export function HttpLoaderFactory(http: HttpClient, environment: EnvironmentConfiguration) {
  return new GeaTranslateHttpLoader(http, environment.localizationStorageURL, [], ['/assets/i18n/']);
}



@NgModule({
  declarations: [
    AppComponent,
    DigitalComponent,
    TableComponent,
    TrendV2Component,
    OverviewComponent,
    ProcessComponent,
    VerticalBarComponent,
    PieComponent,
    CipComponent,
    DatepickerComponent,
    CardLastChangeComponent,
    CardNextAuditComponent,
    ListOfCipComponent,
    ListOfProductionComponent,
    StatusTableComponent,
    GanttComponent,
    ConsumptionComponent,
    FluxTestComponent,
    ChemicalComponent,
    ServiceComponent,
    TrendPopupComponent,
    TreeViewComponent,
    ShowTimePopupComponent,
    HeaderComponent,
    MachineTypeDirective,
    DigitalConsumComponent,
    DigitalConsumV2Component,
    DigitalConsumV3Component
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    NgChartsModule,
    PageLayoutModule,
    SidebarV2Module,
    MsalModule,
    NgxsModule.forRoot([UserState, ActionRequiredState, AppEnvironmentState, PermissionsState, FeatureFlagConfigurationState], {
      compatibility: {
        strictContentSecurityPolicy: true,
      },
      selectorOptions: { suppressErrors: true }
    }),

    TranslateModule.forRoot({
      extend: true,
      defaultLanguage: 'en-US',
      useDefaultLang: false,
      loader: {
        deps: [HttpClient, ENVIRONMENT_CONFIG],
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: GeaMissingTranslationHandler,
      },
    }),
    HeaderModule.forRoot(HEADER_CONFIG),

    // HeaderModule.forRoot({
    //   redirectUri: environment.redirectUri,
    //   postLogoutRedirectUri: environment.postLogoutRedirectUri,
    //   clientId: environment.clientId,
    //   authority: environment.authority,
    //   authorityDomain: environment.authorityDomain,
    //   portalURL: environment.portalUrl,
    //   urls: {
    //     // userAdmin: '/user',
    //     // orgaAdmin: '/organization',
    //     // invitations: '/invitation',
    //     resources: '/configuration/resources',
    //     permission: '',
    //     // memberships: 'user/administration/users/${id}/memberships/',
    //     // orgasAndRoles: 'user/administration/organization/roles/',
    //   },
    // }),
    TableV2Module
  ],
  providers: [
    TranslatePipe,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: LIBRARY_CONFIG,
      useFactory: (env: EnvironmentConfiguration) => {
        return {
          ...env,
          baseUrl: env.portal.baseURL ?? env.baseURL,
          backendInfoUrl: (env.portal.baseURL ?? env.baseURL) + 'geaid/v1/info',
          legalDocumentsStorageURL: env.storageURL,
        };
      },
      deps: [ENVIRONMENT_CONFIG],
    },
    MsalService,
    {
      provide: 'baseUrl',
      useFactory: (env: EnvironmentConfiguration) => env.portal.baseURL ?? env.baseURL,
      deps: [ENVIRONMENT_CONFIG],
    },
    {
      provide: 'storageURL',
      useFactory: (env: EnvironmentConfiguration) => env.localizationStorageURL,
      deps: [ENVIRONMENT_CONFIG],
    },
    {
      provide: 'appContentPath',
      useFactory: (env: EnvironmentConfiguration) => env.appContentStorageURL,
      deps: [ENVIRONMENT_CONFIG],
    }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule { }
